module.exports = __webpack_public_path__ + "static/media/OrderPlacedStamp.1b2caa59.svg";